export const PAYMENT_TYPE = {
  FLEX_PAY: 'flexpay',
  PAY_IN_FULL: 'upfront',
};

const BUNDLE_INDEXES = {
  GOOD_PLAN: 0,
  BETTER_PLAN: 1,
  BEST_PLAN: 2,
  PETS_PLAN: 3,
};

// Get recommended lawn plan index/tier logic based on lawn quiz answers
export function getRecommendedLawnPlanIndex(lawnQuizAnswers) {
  const lawnUseValue = lawnQuizAnswers?.find(
    (q) => q.question === 'lawn-use'
  )?.response;
  const lawnPatchesValue = lawnQuizAnswers?.find(
    (q) => q.question === 'lawn-patches'
  )?.response;

  // if the user has pets, recommend the Pets bundle (index 3)
  if (lawnUseValue === 'use-pets' || lawnUseValue === 'use-trifecta') {
    return BUNDLE_INDEXES.PETS_PLAN;
    // if the user does NOT have patches, recommend the Better bundle (index 1))
  } else if (lawnPatchesValue === 'patches-none') {
    return BUNDLE_INDEXES.BETTER_PLAN;
  }

  // By default, recommend the Best bundle (index 2)
  return BUNDLE_INDEXES.BEST_PLAN;
}
